const MENU_NAVIGATION_KEYS = ['ArrowDown', 'ArrowUp', 'Home', 'End'];

/**
 * Moves focus between the rows of an open overflow menu on web. Paper's Menu
 * focuses the first row on open and closes on Escape, but has no arrow-key
 * handling, so without this a keyboard user can only Tab through the rows.
 *
 * Returns whether the key was handled, so the caller can stop the browser
 * scrolling the page underneath the menu.
 */
export const moveMenuRowFocus = (menu: HTMLElement, key: string): boolean => {
  if (!MENU_NAVIGATION_KEYS.includes(key)) return false;
  const rows = Array.from(
    menu.querySelectorAll<HTMLElement>('[role="button"]')
  );
  if (rows.length === 0) return false;

  const last = rows.length - 1;
  const current = rows.findIndex((row) => row === document.activeElement);
  let next: number;
  if (key === 'Home') next = 0;
  else if (key === 'End') next = last;
  else if (current === -1) next = key === 'ArrowDown' ? 0 : last;
  else if (key === 'ArrowDown') next = current === last ? 0 : current + 1;
  else next = current === 0 ? last : current - 1;

  rows[next].focus();
  return true;
};
